module.exports = "https://cdn.hellotech.com/client-assets/printers_mobile_c0717d2524a9b3db5251b3ac947f421e.webp";